import * as QueryString from "querystring";
import { InitPage } from "../index";
import axios from "axios";

declare let cociTransactionItemsPath: string;

class COCITransaction {
    init() {
        $(".date_picker_gray").datepicker({ dateFormat: "mm/dd/yy" });

        $(".calendar-fonticon").on("click", function (e) {
            e.preventDefault();
            const elm = $(e.currentTarget.previousElementSibling);
            const visible = elm.datepicker("widget").is(":visible");
            elm.datepicker(visible ? "hide" : "show");
        });

        $('.transaction_info').on('click', function () {
            var asset_id = $(this).data('asset');
            var transaction_id = $(this).data('transaction');
            axios.get(`${cociTransactionItemsPath}/${transaction_id}/assets/${asset_id}/`)
                .then((resp) => {
                    var tbody = $('#itemPartsTbody');
                    tbody.html('');
                    var i = 0;
                    var item_parts = resp.data.item_parts.forEach(function (part) {
                        tbody.append(`
                        <tr class='center-content'>
                        <td> ${i + 1} </td>
                        <td style='text-align: left !important; width: 80%'> ${part.part_name} </td>
                        <td> ${part.part_count} </td>
                        </tr>`);
                        i = i + 1;
                    });
                    $('.ItemParts').modal('show');
                })
                .catch(() => {
                    console.log('error');
                });
        });

        $(".accordion-arrow-icon").on("click", (e) => {
            if (e.target.classList.contains("fa-chevron-down")) {
                e.target.classList.remove("fa-chevron-down");
                e.target.classList.add("fa-chevron-up");
            } else {
                e.target.classList.add("fa-chevron-down");
                e.target.classList.remove("fa-chevron-up");
            }
        });
    }
}

export function LoadPage() {
    InitPage("coci transactions", () => {
        const coci_transaction = new COCITransaction();
        coci_transaction.init();
    });
}

